import axios from 'axios';
import { fixImageUrlsInObject } from '../utils/imageUtils';
import { API_CONFIG } from '../config/api';

const API_URL = API_CONFIG.BASE_URL;
const isProduction = window.location.hostname === 'nostalbeat.com.br' ||
  window.location.hostname === 'www.nostalbeat.com.br';

console.log('🔧 API Configuration:');
console.log('🔧 NODE_ENV:', process.env.NODE_ENV);
console.log('🔧 Hostname:', window.location.hostname);
console.log('🔧 Is Production:', isProduction);
console.log('🔧 API URL:', API_URL);

const api = axios.create({
  baseURL: API_URL,
  timeout: API_CONFIG.TIMEOUT,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  // Don't set Content-Type for FormData - let axios handle it
  if (config.data instanceof FormData) {
    delete config.headers['Content-Type'];
  }

  return config;
}, (error) => {
  return Promise.reject(error);
});

// Handle token expiration
api.interceptors.response.use(
  (response) => {
    // Corrigir URLs de imagens na resposta
    if (response.data) {
      response.data = fixImageUrlsInObject(response.data);
    }

    return response;
  },
  (error) => {
    // Only log real errors, not expected 401s for session check
    const isAuthMe = error.config?.url?.includes('/auth/me');

    if (error.response?.status !== 401 || !isAuthMe) {
      console.error('❌ API Error:', {
        url: error.config?.url,
        status: error.response?.status,
        message: error.message
      });
    }

    // Handle network errors (CORS, connection issues)
    if (error.code === 'ERR_NETWORK' || error.code === 'ERR_CANCELED') {
      error.message = 'Erro de conexão. Verifique se a API está acessível.';
    }

    if (error.response?.status === 401) {
      if (!isAuthMe) {
        console.log('🔑 Token expirado ou inválido, limpando sessão');
      }
      localStorage.removeItem('token');
    }

    return Promise.reject(error);
  }
);

export default api;
